module.exports = __webpack_public_path__ + "img/regpack-active.85920590.svg";